
export const GET_PRODUCT_SUCCESS_FASHION = "getProductsSuccessFashion";
export const GET_PRODUCT_FAIL_FASHION = "getProductsFailFashion";


export const GET_PRODUCT_SUCCESS_FASHION1 = "getProductsSuccessFashion1";
export const GET_PRODUCT_FAIL_FASHION1 = "getProductsFailFashion1";
